import React from 'react'
import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'
import cn from 'classnames'
import {palette} from 'styled-tools'
import BankCardLineIcon from 'remixicon-react/BankCardLineIcon'

import {Title7} from 'src/components/typography'
import {theme} from 'src/themes'
import type {
  CreditCardFormErrorProps,
  CreditCardFormValues,
} from './CreditCardFormFields'
import CreditCardFormFields from './CreditCardFormFields'
import {Expandable} from '../common'

interface Props {
  selected?: boolean
  onSelect: () => void
  errors?: CreditCardFormErrorProps
  values?: CreditCardFormValues
  onChange?: (e: React.BaseSyntheticEvent) => void
}

const FormWrapper = styled.div`
  position: relative;

  margin: 16px 0;
  width: 100%;
  border: 1px solid ${palette('black')};
  background-color: ${palette('white')};
  padding: 34px 34px 34px 24px;

  ${media.md`
    padding: 34px;
  `}

  &.selected {
    border: 1px solid ${palette('red')};
  }
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`

const IconContainer = styled.div`
  padding-right: 24px;

  ${media.md`
    padding-right: 50px;
  `}
`

export default function CreditCardForm({
  selected,
  onSelect,
  errors,
  values,
  onChange,
}: Props): JSX.Element {
  return (
    <FormWrapper onClick={onSelect} className={cn({selected})}>
      <TitleWrapper>
        <IconContainer>
          <BankCardLineIcon size={30} color={theme.palette.primary} />
        </IconContainer>
        <Title7>Nýtt greiðslukort</Title7>
      </TitleWrapper>
      <Expandable expanded={selected}>
        <CreditCardFormFields
          errors={errors}
          values={values}
          onChange={onChange}
        />
      </Expandable>
    </FormWrapper>
  )
}
